import React from 'react';
import IconButton from '@mui/material/IconButton';

export type EditorToolbarButtonProps = {
  disabled?: boolean;
  children?: React.ReactNode;
  isActive?: boolean;
  onClick: () => void;
};

export function EditorToolbarButton(props: EditorToolbarButtonProps) {
  const {
    children,
    disabled,
    isActive,
    onClick,
  } = props;

  const handleClick = () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <IconButton
      color={isActive ? 'primary' : undefined}
      disabled={disabled}
      size="small"
      onClick={handleClick}
      tabIndex={-1}
    >
      {children}
    </IconButton>
  );
}
